import testId from "./testId";

/**
 * @param   {String} actualIdentifier
 * @returns {Object}
 */
export default function conditionalTestId(enabled, ifTestId, elseTestId) {
  return testId(enabled ? ifTestId : elseTestId);
}
